import { FC } from 'react';
import * as stylex from '@stylexjs/stylex';
import { formatEventDate } from '@shared/libs/format-event-date';
import { styles } from '../../styles';
import sadFace from '../../assets/sad-face.webp';
import { ChangeDecisionTrigger } from '../change-decision-trigger';

type DeclinedInviteProps = {
  eventName: string;
  dateStart: string;
  dateEnd: string;
  onChangeDecision: () => void;
};

export const DeclinedInvite: FC<DeclinedInviteProps> = ({ eventName, dateStart, dateEnd, onChangeDecision }) => {
  const formattedDate = formatEventDate(dateStart, dateEnd);

  return (
    <>
      <div {...stylex.props(styles.content)}>
        <img src={sadFace} alt="Приглашение отклонено" {...stylex.props(styles.statusIllustration)} />
        <div {...stylex.props(styles.titleContent)}>
          <p {...stylex.props(styles.titleStatus)}>Ты отказался участвовать в мероприятии</p>
          <p {...stylex.props(styles.date)}>{formattedDate}</p>
          <p {...stylex.props(styles.titleInfo)}>{eventName}</p>
        </div>

        <ChangeDecisionTrigger onClick={onChangeDecision} />
      </div>
      <footer {...stylex.props(styles.infoText)}>
        <p>Связаться с организатором </p>
        <p {...stylex.props(styles.infoLink)}>event@sminex.com</p>
      </footer>
    </>
  );
};
